require("!!E:\\dev\\projects\\web\\norrlands_bathroom_configurator\\node_modules\\script-loader\\addScript.js")(require("!!E:\\dev\\projects\\web\\norrlands_bathroom_configurator\\node_modules\\raw-loader\\index.js!E:\\dev\\projects\\web\\norrlands_bathroom_configurator\\node_modules\\source-map-loader\\index.js!E:\\dev\\projects\\web\\norrlands_bathroom_configurator\\src\\assets\\js\\modernizr-2.8.3.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/js/modernizr-2.8.3.min.js
// module id = 496
// module chunks = 3